import React from 'react'
export type NestingVersionsContextType = {
  nesting: boolean
}
export const NestingVersionsContext: React.Context<NestingVersionsContextType> =
  React.createContext<NestingVersionsContextType>({
    nesting: false,
  })
type Props = {
  children: React.ReactNode
  value: NestingVersionsContextType
}
export const NestingVersionsProvider = ({
  children,
  value,
}: Props): React.ReactNode => {
  return (
    <NestingVersionsContext.Provider value={value}>
      {children}
    </NestingVersionsContext.Provider>
  )
}
